<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="mx-auto box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Homework</strong>
        </v-toolbar-title>
      </v-toolbar>
      <br />
      <v-card max-width="700" class="mx-auto">
        <v-container fluid>
          <v-row dense align="center">
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Academic Year&nbsp; : {{ this.ay }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Standard &nbsp; : {{ this.standard }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Division &nbsp; : {{ this.division }}</v-card-text>
              </v-row>
            </v-card>
            <v-card elevation="0" class="mx-auto" max-width="300">
              <v-row align="center">
                <v-card-text class="text-h5 font-weight-bold">Subject &nbsp; : {{ this.subject }}</v-card-text>
              </v-row>
            </v-card>
          </v-row>
        </v-container>
      </v-card>
      <br />
      <v-row align="center" justify="space-around">
        <v-btn color="primary" @click="OpenDialog" :disabled="isvalid == false ? true : false"> Add New HomeWork
        </v-btn>
      </v-row><br>
      <v-row v-if="!isvalid" align="center" justify="space-around">
        <p v-if="!isvalid"><b>{{ Message }}</b></p>
      </v-row>
      <br />
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="hw_list" :search="search" class="mytable">

          <template v-slot:[`item.attachment`]="{ item }">
            <span style="color: grey" v-if="!item.hasAttachment">
              --
            </span>
            <div v-else>
              <v-icon @click="get_hw_attachment_list(item)">mdi-file</v-icon>
            </div>
          </template>

          <template v-slot:[`item.model_answer`]="{ item }">
            <span style="color: grey" v-if="item.model_answer == '-'">--</span>
            <a v-else target="_blank" :href="basepath + item.model_answer">Model Answer</a>
          </template>
          <template v-slot:[`item.url`]="{ item }">
            <a :href="item.url" target="_blank" v-if="item.url != '--'">
              <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
            </a>
            <span v-else style="opacity: 0.5;">{{ item.url }}</span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editHomework(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-avatar style="" size="25" class="delete-avatar">
                <v-icon color="red" class="delete-v-icon mr-2" @click="deleteHomework(item)"
                  :loading="delete_load">delete</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <div>
              <v-btn depressed color="green" :disabled="item.total_submissions == 0"
                @click="evaluate(item)">Evaluation</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-card-title>
            <span class="headline">Add New Homework</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-checkbox dense v-model="is_assignment" color="success"
                    label="Tick the box ONLY IF ONLINE submission is to be done. (un-tick for Material/Assignment when online submission not required)"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-icon color="error">*</v-icon>
                  <v-text-field v-model="title" label="Title" persistent-hint class="mt-n3">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea outlined v-model="description" label="Description" persistent-hint></v-textarea>
                </v-col>

                <v-text-field :disabled="!is_assignment" v-model="total_marks" label="Total Marks" persistent-hint
                  class="mt-n3" type="number">
                </v-text-field>
              </v-row>
              <!-- <v-row>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-col cols="12" sm="6" md="4">
                      <v-icon color="error">*</v-icon>
                      <v-text-field
                        v-model="due_date"
                        @blur="date2 = parseDate2(due_date)"
                        persistent-hint
                        name="start_date"
                        v-on="on"
                        label="Due Date"
                        prepend-icon="event"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-date-picker
                    v-model="due_date"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-row> -->
              <v-row>
                <v-btn class="ma-1" text icon color="primary">
                  <v-icon>mdi-calendar-month</v-icon>
                </v-btn>
                <v-col cols="6">
                  <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="Due Date"
                    v-model="due_date"></v-datetime-picker>
                  <!-- <v-datetime-picker
                  :disabled="!is_assignment"
                    dateFormat="dd-MM-yyyy"
                    timeFormat="hh:mm aa"
                    label="Due Date"
                    v-model="due_date"
                  ></v-datetime-picker> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field label="Link(If Any)" v-model="link" placeholder="URL"
                    @change="validateWebinarURL(link)"></v-text-field>
                </v-col>
              </v-row>
              <div>
                <v-row justify="end">
                  <v-col cols="12" sm="1" md="1">
                    <v-icon @click="plus_file()">mdi mdi-plus-circle</v-icon>
                  </v-col>
                </v-row>
                <v-col cols="9">
                  <div style="color: red;">
                    <strong>*Notes</strong>
                    <ol>
                      <li>Please upload the file in the following format:
                        .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx
                      </li>
                      <li>File size must be less than 10 MB</li>
                    </ol>
                  </div>
                </v-col>
                <v-row v-for="(item, index) in multiple_file" :key="index">
                  <v-col cols="1"><br />
                    <v-icon @click="minus_file(item.idx)">mdi mdi-minus-circle</v-icon>
                  </v-col>
                  <v-col cols="5">
                    <v-file-input v-model="item.a_file" @change="checkextension(item)" label="Attachment"
                      prepend-icon="mdi-paperclip">
                    </v-file-input>
                  </v-col>
                  <v-col cols="5">
                    <v-file-input v-model="item.m_file" @change="Newextension(item)" label="Upload Modal Answer"
                      prepend-icon="mdi-paperclip">
                    </v-file-input>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outlined text @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" dark @click="save" v-if="title">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!---->
      <v-dialog v-model="edit_dialog" max-width="650px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Homework</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-checkbox dense v-model="editedItem.is_assignment" color="success"
                    label="Tick the box ONLY IF ONLINE submission is to be done. (un-tick for Material/Assignment when online submission not required)"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-icon color="error">*</v-icon>
                  <br />
                  <br />
                  <v-text-field v-model="editedItem.title" label="Title" persistent-hint class="mt-n3">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea outlined v-model="editedItem.description" label="Description"
                    persistent-hint></v-textarea>
                </v-col>

                <!-- <v-text-field
                :disabled="!editedItem.is_assignment"
                    v-model="editedItem.marks"
                    label="Total Marks"
                    persistent-hint
                    class="mt-n3"
                    type="number"
                  >
                  </v-text-field> -->
                <v-text-field v-model="editedItem.marks" label="Total Marks" persistent-hint class="mt-n3"
                  type="number">
                </v-text-field>
              </v-row>
              <!-- <v-row>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-col cols="12" sm="6" md="4">
                      <v-icon color="error">*</v-icon>
                      <v-text-field
                        v-model="due_date"
                        @blur="date2 = parseDate2(due_date)"
                        persistent-hint
                        name="start_date"
                        v-on="on"
                        label="Due Date"
                        prepend-icon="event"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-date-picker
                    v-model="due_date"
                    no-title
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-row> -->
              <v-row>
                <v-btn class="ma-1" text icon color="primary">
                  <v-icon>mdi-calendar-month</v-icon>
                </v-btn>
                <v-col cols="6">
                  <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="Due Date"
                    v-model="new_due_date"></v-datetime-picker>
                </v-col>
                <v-col cols="4">
                  <v-text-field disabled label="Current Due Date" persistent-hint class="mt-n3"
                    v-model="editedItem.due_date">
                  </v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-file-input v-model="new_file" label="Attachment" prepend-icon="mdi-paperclip">
                </v-file-input>
              </v-row>
              <template v-if="editedItem.attachment != '-'">
                <a target="_blank" :href="basepath+editedItem.attachment">Current Attachment</a>
                <v-btn text title="Delete attachment" :loading="delete_load" @click="deleteAttachment(editedItem)">
                  <v-icon color="red">mdi-window-close</v-icon>
                </v-btn>
              </template>
              <v-row>
                <v-file-input v-model="model_answer" label="Modal Answer" prepend-icon="mdi-paperclip">
                </v-file-input>
              </v-row>

              <template v-if="editedItem.model_answer != '-'">
                <a target="_blank" :href="basepath+editedItem.model_answer">Current Modal Answer</a>
                <v-btn text title="Delete Current Modal Answer" :loading="delete_load"
                  @click="delete_modal_answer(editedItem)">
                  <v-icon color="red">mdi-window-close</v-icon>
                </v-btn>
              </template> -->

              <v-col cols="9"
                v-if="hw_attachment_list.some(item => item.attachment !== '-' || item.model_answer !== '-')">
                <div style="color: red;">
                  <strong>*Notes</strong>
                  <ol>
                    <li>Please upload the file in the following format:
                      .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx
                    </li>
                    <li>File size must be less than 10 MB</li>
                  </ol>
                </div>
              </v-col>
              <v-row justify="end">
                <v-col cols="12" sm="1" md="1">
                  <v-icon @click="plus_file1()">mdi mdi-plus-circle</v-icon>
                </v-col>
              </v-row>
              <v-simple-table>

                <tbody>
                  <tr v-for="(item, index) in hw_attachment_list" :key="index">
                    <td style="width: 50px;">
                      <v-icon @click="minus_file1(item.id, item.idx)">mdi-minus-circle</v-icon>
                    </td>
                    <!-- Attachment Column -->
                    <td style="width: 500px;">
                      <div>
                        <div class="d-flex align-center justify-start" style="gap: 10px;">
                          <!-- Eye icon -->
                          <!-- <a v-if="item.attachment && item.attachment !== '-'" target="_blank"
                            :href="basepath + item.attachment">
                            <v-icon>mdi-eye</v-icon>
                          </a> -->

                          <!-- File input -->
                          <v-file-input v-model="a_file_edit[index]" label="Attachment" dense hide-details
                            prepend-icon="mdi-paperclip" @change="checkextension1(index)"
                            style="max-width: 250px;"></v-file-input>
                        </div>

                        <!-- Current attachment display below input -->
                        <div v-if="item.attachment && item.attachment !== '-'">
                          <a target="_blank" :href="basepath + item.attachment">Current Attachment</a>
                          <v-btn text title="Delete attachment" :loading="delete_load"
                            @click="delete_hw_attachment(item)">
                            <v-icon color="red">mdi-window-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </td>

                    <!-- Model Answer Column -->
                    <td style="width: 500px;">
                      <div>
                        <div class="d-flex align-center justify-start" style="gap: 10px;">
                          <!-- <a v-if="item.model_answer && item.model_answer !== '-'" target="_blank"
                            :href="basepath + item.model_answer">
                            <v-icon>mdi-eye</v-icon>
                          </a> -->

                          <!-- File input -->
                          <v-file-input v-model="m_file_edit[index]" label="Upload Modal Answer" dense hide-details
                            prepend-icon="mdi-paperclip" @change="Newextension1(index)"
                            style="max-width: 250px;"></v-file-input>
                        </div>

                        <!-- Current modal answer display below input -->
                        <div v-if="item.model_answer && item.model_answer !== '-'">
                          <a target="_blank" :href="basepath + item.model_answer">Current Modal Answer</a>
                          <v-btn text title="Delete Current Modal Answer" :loading="delete_load"
                            @click="delete_hw_model_file(item)">
                            <v-icon color="red">mdi-window-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </v-simple-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" outlined text @click="edit_dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" dark @click="save_edited_homework" v-if="editedItem.title">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <v-dialog v-model="attachment_dialog" width="300px">
      <v-card>

        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Attachemnt</th>
                <th>Model Answer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in hw_attachment_list" :key="index">
                <td>
                  <div v-if="item.attachment != '-'" class="d-flex align-center justify-start" style="gap: 10px;">

                    <a target="_blank" :href="basepath + item.attachment">
                      <v-icon>mdi-eye</v-icon>
                    </a>


                    <!-- <v-file-input v-model="a_file_edit[index]" label="Select File" dense hide-details
                      prepend-icon="mdi-paperclip" style="max-width: 250px;"></v-file-input>

                   
                    <v-btn small color="primary" :loading="isSaving[index]" :disabled="isSaving[index]"
                      v-if="a_file_edit[index]" @click="editFile(item, index)">
                      Save
                    </v-btn> -->
                  </div>
                  <div v-else></div>
                </td>





                <td>
                  <div v-if="item.model_answer != '-'" class="d-flex align-center justify-start" style="gap: 10px;">

                    <a target="_blank" :href="basepath + item.model_answer">
                      <v-icon>mdi-eye</v-icon>
                    </a>

                    <!-- <v-file-input v-model="m_file_edit[index]" label="Select File" dense hide-details
                      prepend-icon="mdi-paperclip" style="max-width: 250px;"></v-file-input>

                    
                    <v-btn small color="primary" :loading="isSaving[index]" :disabled="isSaving[index]"
                      v-if="m_file_edit[index]" @click="editFile(item, index)">
                      Save
                    </v-btn> -->


                  </div>
                  <div v-else></div>
                </td>
              </tr>

            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular @click="OpenDialog" indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
  import axios from "axios";
  import "@/assets/css/color.css";
  import DatetimePicker from "vuetify-datetime-picker";
  export default {
    components: { DatetimePicker },
    data() {
      return {
        multiple_file: [
          {
            a_file: null,
            m_file: null,
            idx: 0
          }
        ],
        attachmentMap: {},
        a_file_edit: [],
        m_file_edit: [],
        isSaving: [], // <-- holds loading state for each Save button
        isvalid: true, Message: null,
        org_id: null,
        link: "",
        not_deleted: true,
        not_deleted_modal_answer: true,
        delete_load: false,
        dialog: false,
        overlay: false,
        snackbar: false,
        search: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        ay: null,
        standard: null,
        division: null,
        subject: null,
        hw_list: [],
        date2: new Date().toISOString().substr(0, 10),
        menu: false,
        due_date: null,
        new_due_date: null,
        title: null,
        description: null,
        new_file: null,
        model_answer: null,
        basepath: null,
        // total_marks: 10,
        total_marks: 0,
        edit_dialog: false,
        is_assignment: false,
        headers: [
          {
            text: "Sr. No.",
            value: "srno",
            align: "center",
          },
          {
            text: "Assigned Date",
            value: "assigned_date",
            align: "center",
          },
          {
            text: "Title",
            value: "title",
            align: "center",
          },
          {
            text: "Description",
            value: "description",
            align: "center",
          },
          {
            text: "URL",
            value: "url",
            align: "center",
          },
          {
            text: "Attachment",
            value: "attachment",
            align: "center",
          },
          // {
          //   text: "Model Answer",
          //   value: "model_answer",
          //   align: "center",
          // },
          {
            text: "Due date",
            value: "due_date",
            align: "center",
          },
          // {
          //   text: "Total Students",
          //   value: "total_students",
          //   align: "center",
          // },
          {
            text: "Total Submissions",
            value: "total_submissions",
            align: "center",
          },
          {
            text: "Total Evaluations",
            value: "total_evaluations",
            align: "center",
          },
          {
            text: "Total Marks",
            value: "marks",
            align: "center",
          },
          {
            text: "Edit",
            value: "edit",
            align: "center",
          },
          {
            text: "Delete",
            value: "delete",
            align: "center",
          },
          {
            text: "Evaluation",
            value: "action",
            align: "center",
          },
        ],
        editedItem: {
          homework_id: null,
          title: null,
          description: [],
          due_date: null,
          marks: null,
          attachment: null,
          model_answer: null,
          is_assignment: null,

        },
        idx: 1,
        attachment_dialog: false,
        hw_attachment_list: [],
        get_hw_attachment_list_loader: false,
      };
    },
    mounted() {
      this.getHomeWorkDetails();
      this.basepath = localStorage.getItem("awspath");
      this.org_id = localStorage.getItem("EPS-tenant");
    },
    methods: {
      checkextension(item) {
        const file = item.a_file;
        if (file) {
          // Check file size (max 10MB)
          if (file.size > 10.5 * 1024 * 1024) {
            this.showSnackbar("red", "File size should be 10MB or less.");
            item.a_file = null;
            return;
          }

          // Check allowed extensions
          const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"];
          const fileName = file.name.toLowerCase();
          const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

          if (!isValid) {
            this.showSnackbar("red", "Only .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx files are allowed.");
            item.a_file = null;
          }
        }
      },

      Newextension(item) {
        const file = item.m_file;
        if (file) {
          // Check file size (max 10MB)
          if (file.size > 10.5 * 1024 * 1024) {
            this.showSnackbar("red", "File size should be 10MB or less.");
            item.m_file = null;
            return;
          }

          // Check allowed extensions
          const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"];
          const fileName = file.name.toLowerCase();
          const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

          if (!isValid) {
            this.showSnackbar("red", "Only .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx files are allowed.");
            item.m_file = null;
          }
        }
      },


      checkextension1(index) {
        const file = this.a_file_edit[index];
        if (file) {
          if (file.size > 10.5 * 1024 * 1024) {
            this.showSnackbar("red", "File size should be 10MB or less.");
            this.a_file_edit[index] = null;
            return;
          }

          const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"];
          const fileName = file.name.toLowerCase();
          const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

          if (!isValid) {
            this.showSnackbar("red", "Only .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx files are allowed.");
            this.a_file_edit[index] = null;
          }
        }
      },

      Newextension1(index) {
        const file = this.m_file_edit[index];

        if (file) {
          const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"];
          const fileName = file.name.toLowerCase();
          const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

          if (!isValidExtension) {
            this.showSnackbar("red", "Only .jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx files are allowed.");
            this.m_file_edit[index] = null;
            return;
          }

          // ✅ Apply file size check after confirming it's a valid file
          const maxSize = 10.5 * 1024 * 1024;
          if (file.size > maxSize) {
            this.showSnackbar("red", "File size should be 10MB or less.");
            this.m_file_edit[index] = null;
            return;
          }
        }
      },






      async editFile(item, index) {
        const aFile = this.a_file_edit[index];
        const mFile = this.m_file_edit[index];

        if (!aFile && !mFile) {
          this.showSnackbar("#f44336", "Please select a file to upload.");
          return;
        }

        this.$set(this.isSaving, index, true); // show loader

        const formData = new FormData();
        formData.append("id", item.id);
        formData.append("isHomeWork", item.isHomeWork);

        if (aFile) formData.append("a_file", aFile);
        if (mFile) formData.append("m_file", mFile);

        try {
          const res = await axios.post("/Homework/edit_hw_attachment_list", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (res.data.flag === "YES") {
            this.showSnackbar("#4caf50", "Update File HomeWork successfully...!");
            this.getHomeWorkDetails();
            this.attachment_dialog = false;
          }
        } catch (error) {
          let msg = "Unexpected error.";
          if (error.response) msg = "Something went wrong.";
          else if (error.request) msg = "Please try again.";
          this.showSnackbar("#f44336", msg);
        } finally {
          this.$set(this.isSaving, index, false); // hide loader
        }
      },


      get_hw_attachment_list(item, fromEdit = false) {
        // console.log("get_hw_attachment_list called with item: " + JSON.stringify(item));
        const data = {
          homework_id: item.homework_id
        };
        this.get_hw_attachment_list_loader = true;

        axios.post("/Homework/get_hw_attachment_list", data)
          .then(res => {
            if (res.data.msg == "200") {
              this.hw_attachment_list = res.data.hw_attachment_list;
              this.a_file_edit = new Array(this.hw_attachment_list.length).fill(null);
              this.m_file_edit = new Array(this.hw_attachment_list.length).fill(null);
              // const attachmentIds = this.hw_attachment_list.map(att => att.id);
              // console.log("HomeworkAttachment IDs:", attachmentIds);
              // this.$set(this.attachmentMap, item.homework_id, attachmentIds);
              this.get_hw_attachment_list_loader = false;

              if (fromEdit) {
                this.edit_dialog = true; // open dialog only if from edit
              } else {
                this.attachment_dialog = true;
              }
            } else {
              this.showSnackbar("#b71c1c", res.data.msg);
              this.get_hw_attachment_list_loader = false;
            }
          });
      },


      plus_file() {
        this.idx++;
        this.multiple_file.push(
          {
            a_file: null,
            m_file: null,
            idx: this.idx
          }
        )
      },

      async getNewHwAttachmentId(homework_id) {
        const data = {
          homework_id: homework_id
        };

        try {
          const res = await axios.post("/Homework/get_new_attachment_id", data);

          if (res.data.msg === "200") {
            return res.data.id; // ✅ This returns the new ID
          } else {
            this.showSnackbar("#b71c1c", "Failed to generate attachment ID");
            return null;
          }
        } catch (err) {
          console.error("Error fetching new attachment ID:", err);
          this.showSnackbar("#b71c1c", "Server error while generating attachment ID");
          return null;
        }
      },



      async plus_file1() {
        this.idx++;
        let homework_id = this.editedItem.homework_id;

        if (!homework_id) {
          this.showSnackbar("#b71c1c", "Homework ID not found");
          return;
        }

        const newId = await this.getNewHwAttachmentId(homework_id);
        // console.log("Returned attachment ID:", newId);

        if (!newId) {
          this.showSnackbar("#b71c1c", "Unable to generate attachment ID");
          return;
        }

        this.hw_attachment_list.push({
          id: newId,
          isHomeWork: false,
          a_file_edit: null,
          m_file_edit: null,
          idx: this.idx,
        });

        this.a_file_edit.push(null);
        this.m_file_edit.push(null);

        return newId;
      },


      minus_file(index) {
        const findIndex = this.multiple_file.findIndex(a => a.idx == index);
        this.multiple_file.splice(findIndex, 1);
      },
      async minus_file1(id, idx) {
        try {

          if (id) {
            const res = await axios.post("/Homework/delete_hwa_id", { id: id });

            if (res.data.msg === "200") {
              const findIndex = this.hw_attachment_list.findIndex(a => a.id === id);
              if (findIndex !== -1) this.hw_attachment_list.splice(findIndex, 1);
            } else {
              this.showSnackbar("#b71c1c", "Failed to delete");
            }
          } else {
            const findIndex = this.hw_attachment_list.findIndex(a => a.idx === idx);
            if (findIndex !== -1) this.hw_attachment_list.splice(findIndex, 1);
          }
        } catch (err) {
          console.error("Delete error:", err);
          this.showSnackbar("#b71c1c", "Cannot delete, it's default row");
        }
      },

      validateWebinarURL(link) {
        // alert("validateWebinarURL::" + link);

        var myURL = link;
        var mytrimurl = myURL.trim();
        var pattern = new RegExp(
          "^((ft|htt)ps?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
          "(\\:\\d+)?" + // port
          "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
          "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator');
        if (this.hasWhiteSpace(this.myURL)) {
          this.isvalid = true;
          return;
        } else if (pattern.test(mytrimurl)) {
          this.isvalid = true;
          return;
        } else {
          this.isvalid = false;
          alert("Please Enter Valid URL...!");

          return;
        }
      },
      deleteHomework(item) {
        if (!confirm("Are You Sure You Want To Delete This HomeWork?"))
          return;
        const data = {
          homework_id: item.homework_id
        };
        this.delete_load = true
        axios
          .post("/Homework/delete_homework", data)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4caf50", "Homework deleted successfully...");
              this.getHomeWorkDetails()
              this.delete_load = false
            } else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.delete_load = false;
          });
      },

      async save_edited_homework() {
        if (this.editedItem.title != null) {
          if (this.hasWhiteSpace(this.editedItem.title)) {
            this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
            return;
          }

          if (this.org_id != 'sbpps') {
            if (this.new_due_date == null || this.new_due_date == '') {
              this.showSnackbar("#b71c1c", "Please Select Due Date..!");
              return;
            }
          }

          this.overlay = true;

          let formData = new FormData();
          formData.append("homework_id", this.editedItem.homework_id);
          formData.append("title", this.editedItem.title);
          formData.append("description", this.editedItem.description);
          formData.append("new_file", this.new_file);
          formData.append("model_answer", this.model_answer);
          formData.append("total_marks", this.editedItem.marks);
          formData.append("is_assignment", this.editedItem.is_assignment);
          formData.append("courseoffering_id", this.$store.getters.course_off_id);
          formData.append("ay_id", this.$store.getters.ay_id);

          if (this.new_due_date != null) {
            var todaysDate = new Date();
            var inputDate = new Date(this.new_due_date);
            if (inputDate.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0)) {
              formData.append("due_date", this.formatDate(this.new_due_date, true));
            } else {
              this.showSnackbar("error", "Older date cannot be proceed, Please choose correct date!");
              this.overlay = false;
              return;
            }
          }

          // 🔁 Loop through files and call upload API
          for (let i = 0; i < this.hw_attachment_list.length; i++) {
            const aFile = this.a_file_edit[i];
            const mFile = this.m_file_edit[i];

            if (aFile || mFile) {

              let fileForm = new FormData();
              fileForm.append("id", this.hw_attachment_list[i].id);
              fileForm.append("isHomeWork", this.hw_attachment_list[i].isHomeWork);
              if (aFile) fileForm.append("a_file", aFile);
              if (mFile) fileForm.append("m_file", mFile);

              try {
                const fileRes = await axios.post("/Homework/edit_hw_attachment_list", fileForm, {
                  headers: { "Content-Type": "multipart/form-data" },
                });

                if (fileRes.data.flag !== "YES") {
                  this.showSnackbar("#f44336", "File upload failed for row " + (i + 1));
                }
              } catch (err) {
                this.showSnackbar("#f44336", "File upload failed for row " + (i + 1));
              }
            }
          }

          // 🔁 Homework Update Call
          axios
            .post("/Homework/edit_homework", formData)
            .then((res) => {
              this.overlay = false;
              if (res.data.flag == "YES") {
                this.editedItem = {};
                this.showSnackbar("#4caf50", "HomeWork Edited successfully!");
                this.getHomeWorkDetails();
              } else if (res.data.flag == "NO") {
                this.showSnackbar("#b71c1c", "Something went wrong!");
              }
              if (res.data.msg == "file_error") {
                this.showSnackbar("#b71c1c", "File not uploaded!");
              }
            })
            .catch((error) => {
              this.overlay = false;
              let msg = "Un-expected error.";
              if (error.response) msg = "Something went wrong.";
              else if (error.request) msg = "Please try again.";
              this.showSnackbar("#f44336", msg);
            })
            .finally(() => {
              this.overlay = false;
              this.edit_dialog = false;
            });
        } else {
          this.edit_dialog = true;
          this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
        }
      },

      deleteAttachment(item) {
        this.delete_load = true;
        const formData = {
          homework_id: item.homework_id
        }
        axios
          .post("/Homework/delete_attachment", formData)
          .then(res => {
            this.not_deleted = res.data.flag
            if (res.data.status == "YES") {
              this.edit_dialog = false;
              this.getHomeWorkDetails();
              this.showSnackbar(
                "#4caf50",
                "Old attachment removed!"
              );

            }
            else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              //alert(res.data.status_reason)	
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader	
            this.delete_load = false;
          });
      },
      delete_modal_answer(item) {
        this.delete_load = true;
        const formData = {
          homework_id: item.homework_id
        }
        axios
          .post("/Homework/delete_modal_answer", formData)
          .then(res => {
            this.not_deleted_modal_answer = res.data.flag
            if (res.data.status == "YES") {
              this.edit_dialog = false;
              this.getHomeWorkDetails();
              this.showSnackbar(
                "#4caf50",
                "Old attachment removed!"
              );

            }
            else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              //alert(res.data.status_reason)	
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader	
            this.delete_load = false;
          });
      },

      delete_hw_attachment(item) {
        alert("delete_hw_attachment::" + item.id);
        this.delete_load = true;
        const formData = {
          id: item.id,                    // homework or attachment ID
          isHomeWork: item.isHomeWork
        }
        axios
          .post("/Homework/delete_hw_attachment", formData)
          .then(res => {
            this.not_deleted_modal_answer = res.data.flag
            if (res.data.status == "YES") {
              // this.edit_dialog = false;
              item.attachment = '-';
              this.getHomeWorkDetails();
              this.showSnackbar(
                "#4caf50",
                "Attachment Removed!"
              );

            }
            else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              //alert(res.data.status_reason)	
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader	
            this.delete_load = false;
          });
      },

      delete_hw_model_file(item) {
        alert("delete_hw_attachment::" + item.id);
        this.delete_load = true;
        const formData = {
          id: item.id,                    // homework or attachment ID
          isHomeWork: item.isHomeWork
        }
        axios
          .post("/Homework/delete_hw_model_file", formData)
          .then(res => {
            this.not_deleted_modal_answer = res.data.flag
            if (res.data.status == "YES") {
              // this.edit_dialog = false;
              item.model_answer = '-';
              this.getHomeWorkDetails();
              this.showSnackbar(
                "#4caf50",
                " ModalAnswer Removed!"
              );

            }
            else if (res.data.status == "NO") {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              //alert(res.data.status_reason)	
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader	
            this.delete_load = false;
          });
      },

      async editHomework(item) {
        if (item.attachment != '-') {
          this.not_deleted = true;
        } else {
          this.not_deleted = false;
        }
        this.editedItem = item;
        this.edit_dialog = true;

        if (item.model_answer != '-') {
          this.not_deleted_modal_answer = true;
        } else {
          this.not_deleted_modal_answer = false;
        }

        // ⬇️ Wait for list to be fetched
        await this.get_hw_attachment_list(item, true);

        // ⬇️ Now initialize the file arrays correctly
        this.a_file_edit = [];
        this.m_file_edit = [];
        for (let i = 0; i < this.hw_attachment_list.length; i++) {
          this.a_file_edit.push(null);
          this.m_file_edit.push(null);
        }
      },



      formatDate(a, withTime) {
        return withTime
          ? `${a.getFullYear()}-${a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
          : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
      },
      hasWhiteSpace(s) {
        var status = false;
        var reWhiteSpace = new RegExp(/^\s+$/);

        // Check for white space
        if (reWhiteSpace.test(s)) {
          // alert("Please Check Your Fields For Spaces");
          return true;
        }
        return false;
      },
      save() {
        if (this.title != null) {

          //   if (this.hasWhiteSpace(this.title)) {
          //   this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
          //   return;
          // }
          // if(this.org_id != 'sbpps'){
          //     if (this.due_date == null || this.due_date=='') {
          //             this.showSnackbar("#b71c1c", "Please Select Due Date..!");
          //             return;
          //       }
          // }

          this.overlay = true;
          this.dialog = false;
          let formData = new FormData();
          formData.append("courseoffering_id", this.$store.getters.course_off_id);
          formData.append("div_off_id", this.$store.getters.div_off_id);
          formData.append("ay_id", this.$store.getters.ay_id);
          formData.append("title", this.title);
          formData.append("description", this.description);
          for (var x in this.multiple_file) {
            formData.append("a_file" + x, this.multiple_file[x].a_file);
            formData.append("m_file" + x, this.multiple_file[x].m_file);
          }
          formData.append("file_count", this.multiple_file.length);
          formData.append("link", this.link);
          formData.append("model_answer", this.model_answer);
          formData.append("total_marks", this.total_marks);
          formData.append("is_assignment", this.is_assignment);
          if (this.due_date != null) {
            var todaysDate = new Date();
            var inputDate = new Date(this.due_date);
            if (
              inputDate.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0)
            ) {
              formData.append("due_date", this.formatDate(this.due_date, true));
            } else {
              this.showSnackbar(
                "error",
                "Older date cannot be proceed, Please choose correct date!"
              );
              this.overlay = false;
              this.dialog = true;
              return;
            }
          }
          axios
            .post("/Homework/add_new_homework", formData)
            .then((res) => {
              this.overlay = false;
              if (res.data.flag == "YES") {
                (this.title = null),
                  (this.due_date = null),
                  (this.description = null),
                  (this.new_file = null),
                  (this.model_answer = null),
                  this.showSnackbar(
                    "#4caf50",
                    "New HomeWork Added successfully!"
                  );
                this.getHomeWorkDetails();
              } else if (res.data.flag == "No") {
                this.isvalid = res.data.isvalid,
                  this.Message = res.data.Message
                this.showSnackbar("red", res.data.Message);
              }
              if (res.data.msg == "file_error") {
                this.showSnackbar("#b71c1c", "File not uploaded!");
              }
            })
            .catch((error) => {
              this.overlay = false;
              this.dialog = false;
              let msg = "";
              if (error.response) {
                msg = "Something went wrong.";
              } else if (error.request) {
                msg = "Please try again.";
              } else {
                msg = "Un-expected error.";
              }
            })
            .finally(() => {
              this.overlay = false;
              this.dialog = false;
            });
          // } else {
          //   // this.showSnackbar(
          //   //   "error",
          //   //   "Older date cannot be proceed, Please choose correct date!"
          //   // );
          // }
          //   var todaysDate = new Date();
          //   var inputDate = new Date(this.due_date);
          // if (
          //   inputDate.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0) &&
          //   inputDate2.setHours(0, 0, 0, 0) >= todaysDate.setHours(0, 0, 0, 0)
          // ) {
          //   if (
          //     inputDate.setHours(0, 0, 0, 0) > inputDate2.setHours(0, 0, 0, 0)
          //   ) {
          //     // console.log("Wrong!");
          //     this.showsnackbar(
          //       "Start date cannot be bigger than End date, please choose correct date!",
          //       "error",
          //       5000
          //     ); // show snackbar
          //   } else {
          //proceed !!!
          // console.log("Proceed further!");
          // axios
          //   .post("/Homework/add_new_homework", formData)
          //   .then((res) => {
          //     this.overlay = false;
          //     if (res.data.flag == "YES") {
          //       (this.title = null),
          //         (this.due_date = null),
          //         (this.description = null),
          //         (this.new_file = null),
          //         this.showSnackbar(
          //           "#4caf50",
          //           "New HomeWork Added successfully!"
          //         );
          //       this.getHomeWorkDetails();
          //     }
          //     if (res.data.msg == "file_error") {
          //       this.showSnackbar("#b71c1c", "File not uploaded!");
          //     }
          //   })
          //   .catch((error) => {
          //     this.overlay = false;
          //     this.dialog = false;
          //     let msg = "";
          //     if (error.response) {
          //       msg = "Something went wrong.";
          //     } else if (error.request) {
          //       msg = "Please try again.";
          //     } else {
          //       msg = "Un-expected error.";
          //     }
          //   })
          //   .finally(() => {
          //     this.overlay = false;
          //     this.dialog = false;
          //   });
          // }
          // } else {
          //   this.dialog = true;
          //   //wronf date!
          //   //console.log("Wrogn Date!");
          //   this.showsnackbar(
          //     "Older date cannot be proceed, Please choose correct date!",
          //     "error",
          //     5000
          //   ); // show snackbar
          // }
        } else {

          this.dialog = true;
          this.showSnackbar("#b71c1c", "HomeWork Title is compulsory!");
        }




      },
      formatDate2(date2) {
        if (!date2) return null;
        const [year, month, day] = date2.split("-");
        return `${day}/${month}/${year}`;
      },
      parseDate2(date2) {
        //console.log(date2)
        if (!date2) return null;
        const [month, day, year] = date2.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
      getHomeWorkDetails() {
        if (
          this.$store.getters.course_off_id == null &&
          this.$store.getters.ay_id == null &&
          this.$store.getters.div_off_id == null
        ) {
          this.$router.push({ name: "teacher-add-homework" });
        }
        const data = {
          course_offering_id: this.$store.getters.course_off_id,
          ay_id: this.$store.getters.ay_id,
          div_off_id: this.$store.getters.div_off_id,
        };
        this.overlay = true;
        axios
          .post("/Homework/fetch_homework_data", data)
          .then((res) => {
            this.overlay = false;
            (this.ay = res.data.academic_year),
              (this.standard = res.data.standard),
              (this.division = res.data.division),
              (this.subject = res.data.subject);
            this.hw_list = res.data.homework_list;
            this.isvalid = res.data.isvalid,
              this.Message = res.data.Message
          })
          .catch((error) => {
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      },
      evaluate(item) {
        this.$store.commit("sethomework_id", item.homework_id);
        this.$router.push({ name: "teacher-check-homework" });
      },
      OpenDialog() {
        this.dialog = true;
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
  };
</script>

<style scoped>
  .mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
  }
</style>